import { lazy } from 'react';

const Dashboard = lazy(() => import('./pages/company/Dashboard'));

export const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "now-ui-icons location_compass-05",
    component: Dashboard,
    layout: "/admin"
  },
]
